/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');
const Clipboard = require('clipboard');
const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const communityMixin = require('../../community/communityMixin');
const methMinxin = require('../../community/methMixin');
const template = require('./detailsTopic-list.tpl');


require('./detailsTopic-list.scss');

const detailsTopic = {
	mixins: [communityMixin,methMinxin],
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},

	data() {
		return {
			thItems: ["详情标题","详情链接与ID","创建日期","话题","手机版本","操作"],
			url: apiPath.community.detailsInfoList,
			pageInitCt: 1,
			model:'topicsContent',
			placeItem:"按详情标题搜索",
			searchName:"detailsTit",
			searchVal: "",
			domain:window.location.hostname+(window.location.port? ':'+window.location.port:""),
		}
	},
	ready(){
		let that = this;
			//that.initZeroClicp();
		
	},
	methods:{
		initZeroClicp(){
      let clipTips = {
        "topicLink":"话题链接",
        "topicId":"话题ID",
        "infoLink":"详情链接",
        "infoId":"详情ID",
        "detailsLink":"详情链接",
        "detailsId":"详情ID"
      }
      let btns = document.getElementsByClassName('zclip');
     	if($('.zclip-tip').length==0){
      	$('body').append('<span class="zclip-tip fa"></span>');
      }
      let $tgZip = $('.zclip-tip').eq(0);
      $(btns).on('mouseover',function(e){
      	let _key = $(this).attr("clipType");
      	let $o = $(this).offset();
      	
      	$tgZip.css({'left':$o.left+($(this).width())/2+'px','top':$o.top+$(this).height()+6+'px'});
      	$tgZip.text('点击复制'+clipTips[_key]);
      	$tgZip.addClass('mover-zclip');
      }).on('mouseout',function(e){
      	$tgZip.removeClass('mover-zclip');
      })
      /*$.each($(btns),function(i,n){
          let _key = $(this).attr("clipType");
          $(this).append('<span class="zclip-tip"><i class="fa fa-sort-up"></i>'+clipTips[_key]+'</span>');
      })*/
      let clipboard = new Clipboard(btns);
      clipboard.on('success', function(e) {
        let _key = e.trigger.getAttribute("clipType")
        let _ms = clipTips[_key] || "";
          tip(`复制${_ms}成功`);
      });
      clipboard.on('error', function(e) {
          let _key = e.trigger.getAttribute("clipType")
          let _ms = clipTips[_key] || "";
          tip(`复制${_ms}失败`);
      });
    },
		searchData(){
			let that = this;
				that.searchVal = that.$refs.userInputbox.val();
				console.log(that.searchVal);
				that.$refs.tableData.query({
					"startTime":that.calendar.items.startTime.value,
					"endTime":that.calendar.items.endTime.value,
					"searchName":that.searchName,
					"searchValue":that.searchVal
				}).fetch();
		},
		
	},
	events:{
		[dropMenuEvent.menu.change](selecObj){
			console.log(selecObj);
			let queryName = selecObj.queryName;
			this[queryName] = selecObj.value;
		}
	},
	components:{
		pop
	}
}

module.exports = detailsTopic;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/details-topic/detailsTopic-list/detailsTopic-list.js